const headers = {
  name: "Project nearby",
  navigate: {
    path: [
      {
        name: "Nearby",
        path: "/app/projects/nearby",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
